import { CurrencyService } from "../services/CurrencyService";
import { OfferBookService } from "../services/OfferBookService";
import { formatMoney } from "../utils/formatters";

export class GraphOfferBook {
  private wrapper: JQuery<HTMLElement>;
  private static CONTENT_ACTIVE_CLASS = "graph-offerbook-content-active";
  private static TAB_ACTIVE_CLASS = "graph-offerbook-tab-active";

  constructor() {
    this.wrapper = $(".graph-offerbook-module-wrapper");

    this.bindEvents();
    this.appendChart();
    this.getData();
  }

  private async getData() {
    const currency = await CurrencyService.getSelected();
    const data = await OfferBookService.get(currency!!);

    const sell = data.sell.map((item) => {
      return $("<tr>", {
        html: [
          $("<td>", { html: formatMoney(item.price) }),
          $("<td>", { html: item.quantity }),
        ],
      });
    });

    const purchase = data.purchase.map((item) => {
      return $("<tr>", {
        html: [
          $("<td>", { html: formatMoney(item.price) }),
          $("<td>", { html: item.quantity }),
        ],
      });
    });

    this.wrapper
      .find(".graph-offerbook-orders-sell .graph-offerbook-orders-table")
      .append(sell);
    this.wrapper
      .find(".graph-offerbook-orders-purchase .graph-offerbook-orders-table")
      .append(purchase);
    this.wrapper.find(".graph-offerbook-code").html(currency?.code as string);

    return data;
  }

  private bindEvents() {
    this.wrapper
      .find(".graph-offerbook-tab")
      .on("click", this.onTabClick.bind(this));
  }

  private onTabClick(event: JQuery.ClickEvent) {
    event.preventDefault();

    const contentId = $(event.target).attr("href");
    this.showContent(contentId as String);
  }

  private showContent(id: String) {
    const content = this.wrapper.find(`.graph-offerbook-content${id}`);
    const tab = this.wrapper.find(`.graph-offerbook-tab[href=${id}]`);

    content
      .addClass(GraphOfferBook.CONTENT_ACTIVE_CLASS)
      .siblings(`.${GraphOfferBook.CONTENT_ACTIVE_CLASS}`)
      .removeClass(GraphOfferBook.CONTENT_ACTIVE_CLASS);

    tab
      .addClass(GraphOfferBook.TAB_ACTIVE_CLASS)
      .siblings(`.${GraphOfferBook.TAB_ACTIVE_CLASS}`)
      .removeClass(GraphOfferBook.TAB_ACTIVE_CLASS);
  }

  private getChartUrl(currency: Currency): string {
    if (!currency?.code) {
      return "";
    }
    return encodeURIComponent(
      `/charting_library/static/pt-tv-chart.4983fae3fbe165749507.html#symbol=BRLX${currency.code}&enabledFeatures="[]"&disabledFeatures="[]"&interval=360&widgetbar={"details":false,"watchlist":false,"watchlist_settings":{"default_symbols":[]}}&timeFrames=[{"text":"5y","resolution":"W"},{"text":"1y","resolution":"W"},{"text":"6m","resolution":"120"},{"text":"3m","resolution":"60"},{"text":"1m","resolution":"30"},{"text":"5d","resolution":"5"},{"text":"1d","resolution":"1"}]&locale=pt&uid=tradingview_90995&clientId=tradingview.com&userId=public_user_id&chartsStorageVer=1.1&debug=false&timezone=America/Sao_Paulo`
    );
    // return '/charting_library/static/pt-tv-chart.4983fae3fbe165749507.html#symbol=BRLXBTC&interval=360&widgetbar={"details":false,"watchlist":false,"watchlist_settings":{"default_symbols":[]}}&timeFrames=[{"text":"5y","resolution":"W"},{"text":"1y","resolution":"W"},{"text":"6m","resolution":"120"},{"text":"3m","resolution":"60"},{"text":"1m","resolution":"30"},{"text":"5d","resolution":"5"},{"text":"1d","resolution":"1"}]&locale=pt&uid=tradingview_7352a&clientId=tradingview.com&userId=public_user_id&chartsStorageVer=1.1&debug=false&timezone=America/Sao_Paulo';
  }

  private async appendChart() {
    return;
    const currency = await CurrencyService.getSelected();
    const iframe = $("<iframe>", {
      src: this.getChartUrl(currency!!),
    });

    this.wrapper.find("#tab1").html(iframe[0]);
  }
}
